// index.js
import Vue from 'vue'
import Router from 'vue-router'
// import store from '@/stores'
Vue.use(Router)

let routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    component: resolve => require(['../pages/Login.vue'], resolve)
  },
  {
    path: '/overview/dorm', // /dorm/access-statistics/full
    component: resolve => require(['@/pages/dorm/access-statistics/index.vue'], resolve)
  },
  {
    path: '/overview/enter', // /dorm/access-statistics/full
    component: resolve => require(['../pages/questionnaire/overview/index.vue'], resolve)
  },
  {
    path: '/overview/enter2', // /dorm/access-statistics/full
    component: resolve => require(['../pages/questionnaire/overview4/index.vue'], resolve)
  },
  {
    path: '/overview/enter3', // /dorm/access-statistics/full
    component: resolve => require(['../pages/questionnaire/overview5/index.vue'], resolve)
  },
  {
    path: '/overview/enter2022', // /dorm/access-statistics/full
    component: resolve => require(['../pages/questionnaire/overview6/index.vue'], resolve)
  },
  {
    path: '/overview/enter2022-spring', // /dorm/access-statistics/full
    component: resolve => require(['../pages/questionnaire/overview7/index.vue'], resolve)
  },
  {
    path: '/overview/welcome-new-student2022', // /dorm/access-statistics/full
    component: resolve => require(['../pages/questionnaire/overview8/index.vue'], resolve)
  },
  {
    path: '/overview/welcome-old-student2022', // /dorm/access-statistics/full
    component: resolve => require(['../pages/questionnaire/overview10/index.vue'], resolve)
  },
  {
    path: '/overview/welcome-all-student2022', // /dorm/access-statistics/full
    component: resolve => require(['../pages/questionnaire/overview80/index.vue'], resolve)
  },
  {
    path: '/overview/welcome-student', // /dorm/access-statistics/full
    component: resolve => require(['../pages/questionnaire/overview80/index.vue'], resolve)
  },
  {
    path: '/activity/dumpling-ticket',
    component: resolve => require(['@/pages/activity/dumpling-ticket.vue'], resolve)
  },
  {
    path: '/redirect', // 重定向路由
    component: resolve => require(['../components/common/redirect.vue'], resolve)
  },
  {
    path: '/approval/dumplingInformation', // /dorm/access-statistics/full
    component: resolve => require(['../pages/approval/dumpling-information.vue'], resolve)
  },
  {
    path: '/welcomeNewStudent/monitor-screen',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/big-screen/monitor-screen.vue'], resolve)
  },
  {
    path: '/welcomeNewStudent/scan',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/big-screen/scan.vue'], resolve)
  },
  {
    path: '/welcomeNewStudent/itemCollection',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/big-screen/itemCollection.vue'], resolve)
  },
  {
    path: '/welcomeNewStudent/selectNumber',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/big-screen/selectNumber.vue'], resolve)
  },
  {
    path: '/dorm/editPlan',
    component: resolve => require(['@/pages/dorm/dormEditPlan'], resolve)
  },
  {
    path: '/dorm/transfer',
    component: resolve => require(['@/pages/dorm/dormTransfer'], resolve)
  },
  {
    path: '/dorm/show',
    component: resolve => require(['@/pages/dorm/dormShow'], resolve)
  },
  {
    path: '/dorm/dormManagementShow',
    component: resolve => require(['@/pages/dorm/dormManagementShow'], resolve)
  },
  {
    path: '/formConfiguration',
    component: resolve => require(['@/pages/formConfiguration/formHomePage.vue'], resolve)
  },
  {
    path: '/welcomeNewStudent/plant/data-analyse',
    component: resolve => require(['@/pages/welcomeNewStudents/pages/dataAnalyse.vue'], resolve),
    name: 'dataAnalyse',
    meta: {
      title: '迎新分析'
    }
  },
  {
    path: '*',
    redirect: '/404'
  }
]

let rootRouter = {
  path: '/',
  // component: resolve => require(['../components/common/Home.vue'], resolve),
  component: resolve => require(['../pages/home/HomeNew.vue'], resolve),
  name: 'home',
  meta: {
    title: '自述文件'
  },
  children: [
    {
      path: '/dashboard',
      name: 'welcome',
      component: resolve => require(['@/pages/navigationMenu/homePage.vue'], resolve),
      meta: {
        title: '系统首页'
      }
    }
  ]
}

const routerFiles = require.context(
  // 其api目录的相对路径
  './modules',
  // 是否查询其子目录
  false,
  // 匹配基础组件文件名的正则表达式
  /[\w-]+\.js$/
)

routerFiles.keys().forEach(fileName => {
  // 获取组件配置
  const routerFile = routerFiles(fileName)
  // 剥去文件名开头的 `./` 和结尾的扩展名
  const routerName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
  if (routerName == 'index') return

  rootRouter.children = rootRouter.children.concat(routerFiles(fileName).default)
})
routes.push(rootRouter)

const router = new Router({
  // mode: 'history',
  routes: routes,
  scrollBehavior: () => {
    history.pushState(null, null, document.URL)
  } //禁用浏览器的返回
})
console.log('router', router)
export default router



// WEBPACK FOOTER //
// ./src/router/index.js